import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BannerHero, Container } from "@/components/site/Layout";
import { Reveal, SectionHead } from "@/components/site/Primitives";
import { ProofGrid } from "@/components/site/Modules";
import { IMPACT_COPY } from "@/lib/content";
import { useSeo } from "@/lib/useSeo";

const H2 = ({ children }) => <h2 className="font-display text-4xl font-bold uppercase leading-[0.95] sm:text-5xl lg:text-6xl">{children}</h2>;

export default function ImpactPage() {
  useSeo({ title: "Our Impact | America First Refining", description: "How America First Refining is working with Brownsville and the Rio Grande Valley: jobs, apprenticeships, local partnerships and cleaner fuels.", path: "/our-impact" });
  return (
    <div data-testid="impact-page">
      <BannerHero testId="impact-banner" title="Impact" image="/img/afr-impact.jpg" alt="Group of community members walking together with arms around each other" intro={IMPACT_COPY.intro} />
      <Container testId="together-section">
        <div className="grid gap-12 lg:grid-cols-12">
          <Reveal className="lg:col-span-5"><H2>Working together for a better tomorrow</H2></Reveal>
          <Reveal delay={0.1} className="space-y-4 text-base leading-relaxed md:text-lg lg:col-span-7">
            {IMPACT_COPY.together.map((p) => <p key={p.slice(0, 30)}>{p}</p>)}
          </Reveal>
        </div>
      </Container>
      <Container testId="solutions-section" tone="dark">
        <Reveal className="text-center"><h2 className="font-display text-4xl font-bold uppercase sm:text-5xl lg:text-6xl">Advanced energy solutions</h2></Reveal>
        <div className="mt-12 grid gap-px border border-white/15 bg-white/15 md:grid-cols-3">
          {IMPACT_COPY.solutions.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.08} className="flex flex-col items-center bg-[#001870] p-10 text-center">
              <img src={s.icon} alt="" aria-hidden="true" className="h-20 w-20" />
              <h3 className="font-display mt-5 text-3xl font-bold uppercase">{s.title}</h3>
            </Reveal>
          ))}
        </div>
      </Container>
      <Container testId="commitment-section">
        <div className="grid gap-12 lg:grid-cols-12">
          <Reveal className="lg:col-span-5"><H2>Our commitment</H2></Reveal>
          <Reveal delay={0.1} className="space-y-4 text-base leading-relaxed md:text-lg lg:col-span-7">
            {IMPACT_COPY.commitment.map((p) => <p key={p.slice(0, 30)}>{p}</p>)}
          </Reveal>
        </div>
      </Container>
      <Container testId="impact-proof-section" tone="soft">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHead eyebrow="Proof, not promises" title="Impact you can check" body="Port facts are current. Job figures are projections from AFR's own materials and are labeled that way." />
            <Link to="/contact?audience=community" data-testid="community-contact-cta" className="group inline-flex items-center gap-2 bg-[#001870] px-6 py-4 font-semibold text-white">Ask a community question <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></Link>
          </div>
          <div className="lg:col-span-8"><ProofGrid /></div>
        </div>
      </Container>
    </div>
  );
}
